import { NgModule } from '@angular/core';

import { TaggerModule } from './../../forms/tagger/tagger.module';
import { EmailsInputComponent } from './emails-input.component';

@NgModule({
  declarations: [EmailsInputComponent],
  exports: [EmailsInputComponent],
  imports: [TaggerModule],
})
export class EmailsInputModule {}
export { EmailsInputComponent } from './emails-input.component';
